import { CtaStrip, FeatureIntro, HeroCentered, HeroCollage, HeroSplit, HeroStat, Paths, Stats, Testimonial } from '@kevlarcon/pages';
import TaxCredit from '../components/sections/TaxCredit';
import States from '../components/sections/States';
import StateTemplatePage from '../components/sections/StateTemplatePage';
import PartnerMap from '../components/sections/PartnerMap';
import PartnerEntry from '../components/sections/PartnerEntry';
import PartnerDirectory from '../components/sections/PartnerDirectory';
import PartnerJoinFormSection from '../components/sections/PartnerJoinFormSection';
import DonateFormSection from '../components/sections/DonateFormSection';
import ApplyGateSection from '../components/sections/ApplyGateSection';
import { homeSectionPreviews } from '../components/sections/previews';

/**
 * Resolves a `Section.section_type` to the component that renders it (see
 * @kevlarcon/pages' `GenericPage.renderSectionContent`) — `section_type` is
 * the map key itself, and the component is called directly with
 * `Section.data` as flat props. See `tenant_site/section_types.py` for each
 * one's field spec, which this map's components must match exactly. Every
 * shape but `TaxCredit`, `States` and `StateTemplatePage` has no
 * tenant-specific logic, so both spec and component for those now live
 * upstream in `@kevlarcon/pages` / `pages.section_types_library` instead of
 * locally (including `FeatureIntro`, since its icon field now resolves
 * through `@kevlarcon/pages`' own `createHeroiconRenderer` — see
 * `frontend/src/site/heroicons.tsx`) — `TaxCredit`, `States` and
 * `StateTemplatePage` stay local because part of each is live `state_config`
 * data rather than admin-authored content (`TaxCredit`'s participating-state
 * pills, and `States`'/`StateTemplatePage`'s coverage maps — see their own
 * files). `PartnerMap` is local for the same reason (live partner pins).
 * `PartnerJoinForm` (tenant_site/section_types.py) is local for the
 * same "not a generic package concern" reason: it's the Partner-With-Us
 * System Page's bespoke, locked form embed (see
 * tenant_site/system_pages.py's PartnerJoinPage), not admin-authored content.
 * `DonateForm`/`ApplyGate` are the same shape again, for the Donate/Apply
 * System Pages — each embeds real, tenant-agnostic functionality (a live
 * Stripe gift flow; a Section 25F launch-date gate) that used to live in a
 * hardcoded `/donate`/`/apply` route before those routes were retired in
 * favor of ordinary CMS pages.
 */
export const homeCustomComponents = {
  HeroCollage,
  HeroSplit,
  HeroCentered,
  HeroStat,
  Stats,
  Paths,
  FeatureIntro,
  Testimonial,
  CtaStrip,
  TaxCredit,
  States,
  StateTemplatePage,
  PartnerMap,
  PartnerEntry,
  PartnerDirectory,
  PartnerJoinForm: PartnerJoinFormSection,
  DonateForm: DonateFormSection,
  ApplyGate: ApplyGateSection,
};

/**
 * Miniature previews for the section-type picker (`PagesConfig.previewComponents`,
 * see SitePagesProvider.tsx) — one entry per registered key above. See
 * `components/sections/previews.tsx` for the actual SVGs.
 */
export { homeSectionPreviews };
